import { createSelector } from 'reselect';

import { PendingChangesActionType } from 'constants/pendingChanges';

import { selectLoanApplication } from './loanApplication.selectors';

const selectCustomFieldValuesState = createSelector(
  selectLoanApplication,
  ({ customFieldValues }) => customFieldValues,
);

export const selectCustomFieldValuesByApplicationId = applicationId =>
  createSelector(
    selectCustomFieldValuesState,
    state => state?.byApplicationId?.[applicationId] ?? [],
  );

export const selectHasPendingCustomFieldChangesByApplicationId = applicationId =>
  createSelector(selectCustomFieldValuesByApplicationId(applicationId), values =>
    values.some(
      value =>
        value?.pendingChangesActionType &&
        value.pendingChangesActionType !== PendingChangesActionType.NO_CHANGES,
    ),
  );
